// extracted by mini-css-extract-plugin
export const contacts = "Contacts-module--contacts--3rFuK";
export const contacts__list = "Contacts-module--contacts__list--2qLtE";
export const contacts__listItem = "Contacts-module--contacts__list-item--O3-MV";
export const contacts__listItemLink = "Contacts-module--contacts__list-item-link--3DPkE";